// Simple encryption function (consider using a more robust method in production)
function encrypt(text: string): string {
  return btoa(text); // Base64 encoding for simplicity
}

// Simple decryption function
function decrypt(text: string): string {
  return atob(text); // Base64 decoding
}

export async function saveCredentials(clientId: string, clientSecret: string): Promise<void> {
  localStorage.setItem("agrello_client_id", encrypt(clientId));
  localStorage.setItem("agrello_client_secret", encrypt(clientSecret));
}

export function getCredentials(): { clientId: string; clientSecret: string } | null {
  const encryptedClientId = localStorage.getItem("agrello_client_id");
  const encryptedClientSecret = localStorage.getItem("agrello_client_secret");

  if (!encryptedClientId || !encryptedClientSecret) {
    return null;
  }

  return {
    clientId: decrypt(encryptedClientId),
    clientSecret: decrypt(encryptedClientSecret),
  };
}

export async function clearCredentials(): Promise<void> {
  localStorage.removeItem("agrello_client_id");
  localStorage.removeItem("agrello_client_secret");
}
